"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("../styles");

var _component = require("../component");

var _context = require("./context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var CardGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(CardGroup, _PureComponent);

  function CardGroup(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      scroller: undefined
    };
    _this.bindScroller = _this.bindScroller.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = CardGroup.prototype;

  _proto.getGap = function getGap() {
    var _this$props = this.props,
        gap = _this$props.gap,
        gutter = _this$props.gutter;
    if (gutter !== undefined) return gutter;
    return gap;
  };

  _proto.bindScroller = function bindScroller(ref) {
    var scroller = this.state.scroller;
    if (scroller || !ref) return;
    this.setState({
      scroller: ref
    });
  };

  _proto.renderBody = function renderBody() {
    var _this$props2 = this.props,
        cardWidth = _this$props2.cardWidth,
        columns = _this$props2.columns,
        children = _this$props2.children,
        other = _objectWithoutPropertiesLoose(_this$props2, ["cardWidth", "columns", "children"]);

    var scroller = this.state.scroller;
    if (!children) return children;
    var gap = this.getGap();
    var context = {
      container: scroller
    };

    var gridStyle = _objectSpread({
      gridRowGap: gap,
      gridColumnGap: gap
    }, other.gridStyle, {
      gridTemplateColumns: cardWidth !== undefined ? "repeat(auto-fill, minmax(" + cardWidth + "px, 1fr))" : "repeat(" + columns + ", 1fr)"
    });

    return _react.default.createElement(_context.Provider, {
      value: context
    }, _react.default.createElement("div", {
      className: (0, _styles.cardGroupClass)('scroller'),
      ref: this.bindScroller
    }, _react.default.createElement("div", {
      style: gridStyle,
      className: (0, _styles.cardGroupClass)('grid')
    }, scroller && children)));
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        height = _this$props3.height,
        style = _this$props3.style,
        className = _this$props3.className;
    var cls = (0, _classnames.default)((0, _styles.cardGroupClass)('_'), className);

    var groupStyle = _objectSpread({
      height: height
    }, style);

    return _react.default.createElement("div", {
      style: groupStyle,
      className: cls
    }, this.renderBody());
  };

  return CardGroup;
}(_component.PureComponent);

CardGroup.defaultProps = {
  columns: 3,
  gap: 16
};
CardGroup.propTypes = {
  style: _propTypes.default.object,
  children: _propTypes.default.array,
  className: _propTypes.default.string,
  height: _propTypes.default.number,
  cardWidth: _propTypes.default.number,
  columns: _propTypes.default.number,
  gridStyle: _propTypes.default.object,
  gap: _propTypes.default.number,
  gutter: _propTypes.default.number
};
var _default = CardGroup;
exports.default = _default;